import logo from "assets/img/logo.webp";
import logoBranca from "assets/img/logoBranca.webp";
import classNames from "classnames";
import { useAppContext } from "providers/AppProvider";

interface LogoProps {
  width?: number;
  text?: boolean;
  textClass?: string;
  className?: string;
}

const Logo = ({ width = 27, text = true, textClass, className }: LogoProps) => {
    const {
      config: { theme },
    } = useAppContext();
    
    return (
      <div className={classNames(className, "d-flex align-items-center")}>
        <img src={theme === "light" ? logo : logoBranca} alt="phoenix" width={width} />
        {text && (
          <p className={classNames(textClass, "logo-text ms-2")}>phoenix</p>
        )}
      </div>
    );
};

export default Logo;
